/** Extendable class from Angular tut on dynamic form generation */
export class QuestionBase<T> {
    value: T | undefined;
    key: string;
    label: string;
    required: boolean;
    disabled: boolean;
    showChildQuestion: boolean;
    order: number;
    controlType: string;
    type: string;
    options: { key: string; value: string }[];
    childQuestion: QuestionBase<any> | undefined;

    constructor(
        options: {
            value?: T;
            key?: string;
            label?: string;
            required?: boolean;
            disabled?: boolean;
            showChildQuestion?: boolean;
            order?: number;
            controlType?: string;
            type?: string;
            options?: { key: string; value: string }[];
            childQuestion?: any;
        } = {},
    ) {
        this.value = options.value;
        this.key = options.key || '';
        this.label = options.label || '';
        this.required = !!options.required;
        this.disabled = !!options.disabled;
        this.showChildQuestion = !!options.showChildQuestion;
        this.order = options.order === undefined ? 1 : options.order;
        this.controlType = options.controlType || '';
        this.type = options.type || 'text';
        this.options = options.options || [];
        this.childQuestion = options.childQuestion
            ? new QuestionBase<any>(options.childQuestion)
            : undefined;
    }
}
